var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradient2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "2560px",
    height: "2560px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 2560 2560",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "id0",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.89174 1.5408 -1.5625 -1.86547 6806 -2585)",
    cx: 2201.6,
    cy: 281.6,
    r: 725.76,
    fx: 2201.6,
    fy: 281.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#6546BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588235,
    stopOpacity: 1,
    stopColor: "#6F4ABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#784DBF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "id1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.76136 0.770401 -0.828332 1.54039 45 -872)",
    cx: 665.6,
    cy: 665.6,
    r: 570.24,
    fx: 665.6,
    fy: 665.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#F7B1CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458824,
    stopOpacity: 1,
    stopColor: "#FBB1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#FFB1C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "id2",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.99728 1.59439 -1.61685 -1.96954 7314 -3106)",
    cx: 2329.6,
    cy: 204.8,
    r: 596.16,
    fx: 2329.6,
    fy: 204.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#6546BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431373,
    stopOpacity: 1,
    stopColor: "#6F4ABD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#784DBF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "id3",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.26074 1.52635 -1.54785 2.22934 0 0)",
    cx: -0.0011811,
    cy: 0,
    r: 414.721,
    fx: -0.0011811,
    fy: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#EBD0A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431373,
    stopOpacity: 1,
    stopColor: "#F3BCB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#FAA8C7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "id4",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.97408 -1.92412 1.28935 1.44276 -3277 -952)",
    cx: 76.7988,
    cy: 2483.2,
    r: 1062.72,
    fx: 76.7988,
    fy: 2483.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#B68EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619608,
    stopOpacity: 1,
    stopColor: "#AF8AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#A887E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "id5",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.99892 -1.5408 1.01569 1.44452 -2493 -737)",
    cx: 179.199,
    cy: 2278.4,
    r: 751.68,
    fx: 179.199,
    fy: 2278.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#B086EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619608,
    stopOpacity: 1,
    stopColor: "#AC87EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#A887E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "id6",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.60625 -1.75651 1.86879 -1.55583 1738 9474)",
    cx: 2227.2,
    cy: 2176,
    r: 648,
    fx: 2227.2,
    fy: 2176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#D294CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690196,
    stopOpacity: 1,
    stopColor: "#BD8DD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#A887E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "id7",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.60625 -1.75651 1.86879 -1.55583 1738 9474)",
    cx: 2227.2,
    cy: 2176,
    r: 648,
    fx: 2227.2,
    fy: 2176
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#D294CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690196,
    stopOpacity: 1,
    stopColor: "#BD8DD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#A887E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "id8",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.58854 1.12478 -1.22085 1.15533 223 -1103)",
    cx: 896,
    cy: 614.4,
    r: 777.6,
    fx: 896,
    fy: 614.4
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#FAA7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658824,
    stopOpacity: 1,
    stopColor: "#D197D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#A887E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "id9",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.3625 0.610156 -0.318486 -1.54806 8444 -1466)",
    cx: 2508.8,
    cy: 25.6004,
    r: 648,
    fx: 2508.8,
    fy: 25.6004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#7947BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658824,
    stopOpacity: 1,
    stopColor: "#9167D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#A887E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "id10",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(2.13778 0.175089 -0.194802 1.37409 0 0)",
    cx: -0.0011811,
    cy: 0,
    r: 285.121,
    fx: -0.0011811,
    fy: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#DCBEA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54902,
    stopOpacity: 1,
    stopColor: "#DEC0A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#E0C2AC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "id11",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.193015 -1.39578 1.56784 0.185046 -770 1376)",
    cx: 537.6,
    cy: 768,
    r: 440.64,
    fx: 537.6,
    fy: 768
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#FAA5C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.329412,
    stopOpacity: 1,
    stopColor: "#FDAACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#FFAED2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id0)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id1)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id2)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id3)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id4)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id5)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id6)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id7)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id8)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id9)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id10)",
    width: 2560,
    height: 2560
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#id11)",
    width: 2560,
    height: 2560
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient2);
export default __webpack_public_path__ + "static/media/gradient2.fc8430941ee3b87fa4354ce050bbb2c2.svg";
export { ForwardRef as ReactComponent };